import { CheckTickFilled, } from '@tag/tag-icons';

import styles from './check-icon.module.scss';

export default function PlusIcon() {
  return (
    <div className={styles.wrapper}>
      <CheckTickFilled
        accent="white"
      />
    </div>
  );
}
